import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SearchModule } from './components/search/search.module';
import { SharedComponentsModule } from './components/shared-components.module';
import { SharedDirectivesModule } from './directives/shared-directives.module';
import { SharedPipesModule } from './pipes/shared-pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from './confirmation-dialog/confirmation-dialog.service';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { InfinityValidators } from './validators/infinity-validators';
import { LoaderComponent } from './loader/loader.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateEditFilesBoxComponent } from './shared-component/file-box/create-edit-files-box/create-edit-files-box.component';
import { ViewImagesComponent } from './view-images/view-images.component';
import { CurrencyWordsPipe } from './pipes/currency-words.pipe';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { TwoDigitDecimaNumberDirective } from './directives/two-digit-decimal-number-directive';
import { DispatchBoardLoaderComponent } from './dispatch-board-loader/dispatch-board-loader.component';
import { PhoneInputDirective } from './directives/shared-directives.module';
import { GptPopupComponent } from './ai-dialog/gpt-popup/gpt-popup.component';

@NgModule({
  declarations:[ConfirmationDialogComponent , LoaderComponent,CreateEditFilesBoxComponent ,
    ViewImagesComponent,
    TwoDigitDecimaNumberDirective,
    DispatchBoardLoaderComponent,
    GptPopupComponent
  ],
  imports: [
    CommonModule,
    SearchModule,
    ToastrModule.forRoot(),
    NgbModule,
    SharedComponentsModule,
    SharedDirectivesModule,
    SharedPipesModule,
    RouterModule,
    TranslateModule,
    NgxDatatableModule,
    FormsModule, // Add FormsModule here,
    NgxMaskDirective, 
    NgxMaskPipe,
    ReactiveFormsModule
    
  ],
  exports: [
    NgxDatatableModule,
    NgbModule,
    ToastrModule,
    TranslateModule,
    SharedPipesModule,
    LoaderComponent,
    ViewImagesComponent,
    NgxMaskDirective, 
    NgxMaskPipe,
    TwoDigitDecimaNumberDirective,
    PhoneInputDirective,
    DispatchBoardLoaderComponent,
    GptPopupComponent,
    ReactiveFormsModule
  ],
  providers:[ConfirmationDialogService ,InfinityValidators,provideNgxMask()]
})
export class SharedModule { }
